export default __webpack_public_path__ + "static/media/mrimachinebluebg.af5eeec1.svg";